// extracted by mini-css-extract-plugin
module.exports = {"sourceMaterialIDLinks":"SourceMaterialIDsLink_sourceMaterialIDLinks__mwit_","title":"SourceMaterialIDsLink_title__CzIkB"};